import { get, handleUnauthorized } from './api';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://local-be.vnz98.online';
const REPORTS_ENDPOINT = '/api/reports';

const buildReportUrl = (path = '') => `${API_BASE_URL}${REPORTS_ENDPOINT}${path}`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
    accept: 'application/json'
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

export const fetchReportDefinitions = async () => {
  const response = await get(REPORTS_ENDPOINT);
  return response;
};

export const exportReportFile = async ({ reportId, startTimestamp, endTimestamp, clientId }) => {
  const endpoint = buildReportUrl(`/${reportId}/export`);

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({
      startTimestamp,
      endTimestamp,
      clientId
    })
  });

  // Handle 401 Unauthorized - automatically logout and redirect to login
  if (response.status === 401) {
    handleUnauthorized();
    throw new Error('Unauthorized: Session expired. Please log in again.');
  }

  if (!response.ok) {
    const errorMessage = await response.text();
    throw new Error(errorMessage || 'Failed to export report');
  }

  return response.blob();
};

export const exportCollectionReport = async ({ startTimestamp, endTimestamp, receiverName }) => {
  const endpoint = buildReportUrl('/malbon-cash-collect');

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({
      startTimestamp,
      endTimestamp,
      receiverName
    })
  });

  // Handle 401 Unauthorized - automatically logout and redirect to login
  if (response.status === 401) {
    handleUnauthorized();
    throw new Error('Unauthorized: Session expired. Please log in again.');
  }

  if (!response.ok) {
    const errorMessage = await response.text();
    throw new Error(errorMessage || 'Failed to export collection report');
  }

  return response.blob();
};

export default {
  fetchReportDefinitions,
  exportReportFile,
  exportCollectionReport
};

